import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';
import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import Icon from '~/components/Icon';
import Page from '~/components/layout/page/Page';
import Link from '~/components/Link';
import { useCurrencyFormatter } from '~/utils/formatters';
import { useLoaderData } from './shopNow';

function ShopNowReturnCredit({
  credit,
  incentive,
}: {
  credit: number;
  incentive: number;
}) {
  const hasBonus = incentive > 0;
  const currencyFormatter = useCurrencyFormatter();

  return (
    <section className="space-y-3">
      <div
        // TODO - change the usage of brand to avoid opacity for better theming
        className="flex flex-col gap-3 rounded-xl border border-brand/20 bg-brand/5 p-5"
      >
        {/* Heading */}
        <p className="subheading-sm text-brand">Your credit</p>

        <div className="flex items-center gap-2">
          {/* Balance amount */}
          <span className="subheading-lg text-on-surface">
            {currencyFormatter(credit)}
          </span>

          {/* Incentive pill */}
          {hasBonus && (
            <span className="inline-flex items-center gap-2 rounded-full bg-surface-container-lowest px-3 py-1 label-lg text-brand/90 shadow-xs">
              <Icon icon="CheckCircle" className="size-4 text-brand" />+{' '}
              {currencyFormatter(incentive)} bonus
            </span>
          )}
        </div>
      </div>
    </section>
  );
}

// TODO: SHOP NOW decide what button layout, we want to implement before go live
// TODO: determine if merchant configured text makes sense here
export default function ShopNowPage() {
  const { credit, incentive, benefits } = useLoaderData();

  return (
    <Page.Root title="Shop Now" hideHeader className="gap-8">
      <ShopNowReturnCredit credit={credit} incentive={incentive} />
      <Page.Section
        title="Why shop now?"
        subtitle="Put your credit to work instantly to get your new items faster."
      >
        <dl
          className={twMerge(
            'grid grid-cols-[auto_1fr] space-y-3 gap-x-3',
            !benefits.some((b) => b.icon) && 'gap-x-0',
          )}
        >
          {benefits.map(({ icon, label, description }) => (
            <Fragment key={label}>
              <dt className="contents">
                {icon && (
                  <Icon icon={icon} className="size-4 self-center text-brand" />
                )}
                <span className="col-start-2 label-lg text-on-surface">
                  {label}
                </span>
              </dt>
              <dd className="col-start-2 body-md text-on-surface-variant">
                {description}
              </dd>
            </Fragment>
          ))}
        </dl>
      </Page.Section>

      <Form className="flex flex-col gap-4">
        <Submit name="shopNow" value="yes">
          Start Shopping
        </Submit>
        <Link to="../address" relative="path">
          No thanks, continue with return
        </Link>
      </Form>
    </Page.Root>
  );
}
